import type { CSSProperties, ReactNode } from 'react';
import { Tag } from 'antd';
import { COLOR } from '@styles/theme';

export function coloredTagStyle(color?: string): CSSProperties {
  const base: CSSProperties = {
    margin: 0,
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 1.25,
  };
  if (!color) return base;
  return {
    ...base,
    backgroundColor: color,
    borderColor: color,
    color: COLOR.white,
  };
}

type ToteTagProps = {
  children: ReactNode;
  color?: string;
  className?: string;
  style?: CSSProperties;
};

export function ToteTag({ children, color, className, style }: ToteTagProps) {
  return (
    <Tag className={className} style={{ ...coloredTagStyle(color), ...style }}>
      {children}
    </Tag>
  );
}
